import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20anime%20style%20illustration%20with%20dramatic%20composition%2C%20silhouetted%20figures%20against%20a%20stunning%20sunset%20sky%20with%20crimson%20and%20golden%20clouds%2C%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20cinematic%20widescreen%20feel%2C%20warm%20rich%20color%20palette%2C%20atmospheric%20lighting%2C%20artistic%20anime%20background%2C%20emotional%20and%20captivating%20mood&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
        alt="里番动漫精选推荐"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="text-center px-4 w-full max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
            探索<strong className="text-accent-300">里番动漫</strong>的精彩世界
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            精选热门里番动漫作品、分类推荐、观看渠道及相关资讯，帮助成人动漫爱好者快速找到优质里番动漫内容，了解里番动漫文化背景与发展历史
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/re-men-tuijian"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-fire-line"></i>
              热门推荐
            </Link>
            <Link
              to="/category/zuixin-fabu"
              className="inline-flex items-center gap-2 px-8 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 font-medium rounded-lg border border-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <i className="ri-rocket-line"></i>
              最新发布
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
        <div className="flex items-center gap-8 text-background-50/60 text-xs md:text-sm">
          <div className="flex items-center gap-2">
            <span className="w-6 h-6 flex items-center justify-center"><i className="ri-article-line"></i></span>
            <span>1,280+ 文章</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-6 h-6 flex items-center justify-center"><i className="ri-folder-line"></i></span>
            <span>26 个分类</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="w-6 h-6 flex items-center justify-center"><i className="ri-user-line"></i></span>
            <span>58,000+ 用户</span>
          </div>
        </div>
      </div>
    </section>
  );
}